export default __webpack_public_path__ + "static/media/ic_gmx.bf8fb0b1.svg";